/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/prop-types */
import React, { Fragment, Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import Pusher from 'pusher-js';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';

import LogIn from '../LogIn/index';
import forgoten from '../forgoten/index';
import MiPanelContent from '../MiPanel/index';
import UsuariosContent from '../Users/index';
import MiCuentaContent from '../MiCuenta/index';
import PasswordContent from '../Password/index';
import Benefits from '../Benefits';
import CasosContent from '../Casos/index';
import Clients from '../Clients';
import ClientsDetail from '../ClientsDetail';
import Cotizaciones from '../Cotizaciones/index';
import Configuration from '../Configuration/index';
import CasoDetalleContent from '../CasoDetalle/index';
import CotizacionesDetalleContent from '../CotizacionesDetalle/index';
import ContactosContent from '../Contactos/index';
import SubtypesContent from '../Subtypes/index';
import EmailTemplateContent from '../Templates/index';

import { /*PUSHER_CHANNEL_NAME, */ PUSHER_CLUSTER, PUSHER_KEY, FIRST_SECOND_CONTACT, casesAllowedList, ROLES } from '../../helper/constants';
import { isOptionAllowed } from '../../shared/utils';
import showNotification from './CallComponent';
class WrappedRoutes extends Component {
  state = {
    lock: false,
  };

  componentDidUpdate() {
    const { currentUser, history } = this.props;
    if (!this.state.lock && currentUser.anexo) {
      this.setState({ lock: true });
      Pusher.logToConsole = true;
      const pusher = new Pusher(PUSHER_KEY, {
        cluster: PUSHER_CLUSTER,
      });
      const channel = pusher.subscribe(currentUser.anexo);
      channel.bind('NEW_CALL', (data) => {
        showNotification({ message: data, history });
        if (isOptionAllowed(['first-contact-executive', 'admin']) && data.quotationId) {
          history.push(`/cotizaciones/${data.quotationId}`);
        }
      });
    }
  }

  render() {
    if (!localStorage.getItem('accessToken')) {
      return <Redirect to="/login" />;
    }
    if (window.location.pathname === '/') {
      if (isOptionAllowed(casesAllowedList)) {
        return <Redirect to="/casos" />;
      }
      if (isOptionAllowed(['sales-executive', ...FIRST_SECOND_CONTACT, ROLES.auditor])) {
        return <Redirect to="/cotizaciones" />;
      }
    }
    return (
      <div>
        <Layout />
        <div className="container__wrap">
          <Route exact path="/mipanel" component={MiPanelContent} />
          {
            isOptionAllowed(['admin', 'admin-port', ROLES.auditor])
            && <Route exact path="/usuarios" component={UsuariosContent} />
          }
          <Route exact path="/micuenta" component={MiCuentaContent} />
          {isOptionAllowed(['admin', 'admin-port', 'manager', ROLES.auditor]) && <Route exact path="/tipificacion" component={SubtypesContent} />}
          {isOptionAllowed(['admin', 'admin-port', 'manager']) && <Route exact path="/configuracion" component={Configuration} />}
          {isOptionAllowed(['admin', 'admin-port', 'manager', ROLES.auditor]) && <Route exact path="/templates" component={EmailTemplateContent} />}

          <Route exact path="/password" component={PasswordContent} />
          {
            isOptionAllowed(casesAllowedList)
            && (
              <Fragment>
                <Route exact path="/casos" component={CasosContent} />
                <Route exact path="/casos/new/:rut" component={CasoDetalleContent} />
                <Route exact path="/casos/:id" component={CasoDetalleContent} />
              </Fragment>
            )
          }
          <Route exact path="/contactos" component={ContactosContent} />
          {
            isOptionAllowed(['admin', 'admin-port', 'manager', 'sales-executive', ...FIRST_SECOND_CONTACT, ROLES.auditor])
            && (
              <Fragment>
                <Route exact path="/cotizaciones" component={Cotizaciones} />
                <Route exact path="/cotizaciones/new/:rut" component={CotizacionesDetalleContent} />
                <Route exact path="/cotizaciones/:id" component={CotizacionesDetalleContent} />
              </Fragment>
            )
          }
          {
            isOptionAllowed(['admin'])
            && (
              <Fragment>
                <Route exact path="/clientes" component={Clients} />
                <Route exact path="/clientes/:id" component={ClientsDetail} />
                <Route exact path="/beneficios" component={Benefits} />
              </Fragment>
            )
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ users }) => ({ ...pick(users, ['currentUser']) });

const WRoutes = connect(mapStateToProps)(WrappedRoutes);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/login" component={LogIn} />
        <Route exact path="/forgoten" component={forgoten} />
        <Route path="/" component={WRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
